app.controller('popupPrintPatientStateOfHealthDocumentationController', ['$scope', '$state', '$mdDialog', 'objectHelper',
    'baseModel', 'applicationModel', 'dictionaryModel', 'userModel', 'doctorModel', 'clinicModel', 'patientModel', 'statementModel',
    'patient', 'guardians', 'statements', 'exportLogEntryModel', '$timeout', 'officeModel',
    function ($scope, $state, $mdDialog, objectHelper, baseModel, applicationModel, dictionaryModel, userModel, doctorModel,
              clinicModel, patientModel, statementModel, patient, guardians, statements, exportLogEntryModel, $timeout, officeModel) {

        var listeners = {};

        function initExportLog(dispension) {
            $scope.exportLogEntry = new ExportLogEntryVO();
            $scope.exportLogEntry.user = userModel.currentUser;
            $scope.exportLogEntry.patient = $scope.patient || new PatientVO();
            $scope.exportLogEntry.dispensed = dispension;

            if(dispension) {
                $scope.exportLogEntry.receiverType = Enum.RECEIVER_TYPE.PATIENT;
                $scope.exportLogEntry.exportType = Enum.EXPORT_TYPE.FULL_PROFILE;
            }

            $scope.exports = {
                fullProfile: false,
                stateOfHealth: false,
                visitList: false,
                personalData: false,
                officeData: false,
                attachments: false
            };
        }

        function beforeSave() {
            if(!!$scope.selected.authorizedPerson) {
                $scope.exportLogEntry.authorizedPerson = {
                    id: $scope.selected.authorizedPerson
                }
            }
            if(!!$scope.selected.guardian) {
                $scope.exportLogEntry.guardian = {
                    id: $scope.selected.guardian
                }
            }
            if($scope.forms.exportLogEntryAllow) {
                $scope.selectedForm = $scope.forms.exportLogEntryAllow;
            }
            if($scope.forms.exportLogEntryDeny) {
                $scope.selectedForm = $scope.forms.exportLogEntryDeny;
            }
            $scope.exportLogEntry.clinic = $scope.currentClinic;
        }

        function setData() {
            $scope.forms = {
                exportLogEntryAllow: null,
                exportLogEntryDeny: null
            };

            $scope.clinic = null;
            $scope.patient = patient;
            $scope.presentDate = new Date();
            $scope.offices = [];
            $scope.guardians = guardians;
            $scope.statements = statements;
            $scope.presentDate = new Date();

            $scope.currentClinic = new ClinicVO();

            $scope.exportLogEntry = new ExportLogEntryVO();

            initExportLog(true);

            $scope.selectedStatement = null;
            $scope.selected = {
                authorizedPerson: null,
                guardian: null
            };

            $scope.Enum = Enum;
            $scope.selectedForm = null;

            $scope.officesForPatient = [];

            $scope.doctorId = userModel.getCurrentContextDoctorId();
        }

        function setPermissions() {
        }

        function setListeners() {

            $scope.$watch('exportLogEntry.receiverType', function(newVal) {
                if(newVal) {
                    if(!!$scope.exportLogEntry.authorizedPerson || $scope.exportLogEntry.guardian) {
                        $scope.exportLogEntry.authorizedPerson = null;
                        $scope.exportLogEntry.guardian = null;
                        delete $scope.exportLogEntry.dispensedTo;
                        $scope.selectedStatement = null;
                        $scope.selectedGuardian = null;
                    }
                }
            }, true);

            $scope.$watch('selected.authorizedPerson', function(newVal) {
                if(typeof newVal === 'number' && $scope.exportLogEntry.receiverType === Enum.RECEIVER_TYPE.AUTHORIZED_PERSON) {
                    $scope.statements.forEach(function(statement) {
                        if(statement.authorizedPerson && statement.authorizedPerson.id === newVal) {
                            $scope.selectedStatement = statement;
                        }
                    })
                }
            }, true);

            $scope.$watch('exportLogEntry.dispensed', function(newVal) {
                if(typeof newVal === "boolean") {
                    initExportLog(newVal);
                    $timeout(function() {
                        $scope.selectedForm = null;
                        if($scope.forms.exportLogEntryAllow) {
                            $scope.forms.exportLogEntryAllow.$setPristine();
                        }
                        if($scope.forms.exportLogEntryDeny) {
                            $scope.forms.exportLogEntryDeny.$setPristine();
                        }
                    })
                }
            });


            $scope.$on(Event.DOCTOR.GET_BY_ID.SUCCESS, function(event, doctor) {
                $scope.doctor = doctor;
                $scope.exportLogEntry.user.id = $scope.doctor.id;
                clinicModel.getById(doctor.individualPractice.id).then(listeners.onClinicGetByIdLoad);
            });

            listeners.onLogEntrySave = function(logEntry) {
                $mdDialog.hide(logEntry);
            };

            listeners.onClinicGetByIdLoad = function(clinic) {
                $scope.currentClinic = clinic;
            };

            listeners.onOfficesForPatientLoad = function(data) {
                $scope.officesForPatient = data;
            }

        }

        function setActions() {
            $scope.save = function() {
                beforeSave();
                $scope.selectedForm.$setSubmitted();

                if($scope.selectedForm.$valid) {
                    exportLogEntryModel.save($scope.exportLogEntry).then(listeners.onLogEntrySave);
                }
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };
        }

        function configureInterface() {

        }

        function initialize() {
            if($scope.doctorId) {
                doctorModel.getById($scope.doctorId);
            }

            officeModel.getOfficesRelatedWithPatient(userModel.currentUser.clinicId, $scope.patient.id).then(listeners.onOfficesForPatientLoad);
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);